import { Moon } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

/**
 * Discreet (hidden from primary chrome) light/dark switch.
 * Lives only in overflow menus — default theme is light for all users.
 */
export function HiddenThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  return (
    <div
      className={cn(
        "mt-3 flex items-center justify-between gap-3 rounded-lg border border-transparent px-3 py-2",
        "text-slate-400 opacity-70 dark:text-slate-500",
        className
      )}
      data-testid="hidden-theme-toggle"
    >
      <label
        htmlFor="hidden-theme-switch"
        className="flex min-h-[44px] flex-1 cursor-pointer items-center gap-2 text-xs"
      >
        <Moon className="h-3.5 w-3.5 shrink-0" aria-hidden />
        <span>Sötét megjelenés</span>
      </label>
      <Switch
        id="hidden-theme-switch"
        checked={theme === "dark"}
        onCheckedChange={(checked) => setTheme(checked ? "dark" : "light")}
        aria-label="Sötét megjelenés"
        data-testid="hidden-theme-switch"
      />
    </div>
  );
}
